export default __webpack_public_path__ + "static/media/ethereumLogo.e274ea81.svg";